//= ../../../bower_components/jquery/jquery.min.js
//= ../../../bower_components/slick-carousel/slick/slick.min.js
//= ../../../bower_components/fancybox/source/jquery.fancybox.pack.js
$(function(){